import * as t from './actionTypes';
import * as actions from './actions';
import type { SystemWebhookReducerState } from './types';

type SystemWebhookReducerAction =
  | ReturnType<typeof actions.createSystemWebhookRequest>
  | ReturnType<typeof actions.deleteSystemWebhookRequest>
  | ReturnType<typeof actions.fetchSystemWebhooksRequest>
  | ReturnType<typeof actions.validateSystemWebhookRequest>
  | ReturnType<typeof actions.updateSystemWebhookRequest>
  | ReturnType<typeof actions.createSystemWebhookResponse>
  | ReturnType<typeof actions.fetchSystemWebhooksResponse>
  | ReturnType<typeof actions.handleSystemWebhooksError>;

export const initialState: SystemWebhookReducerState['integrations']['systemWebhooks'] = {
  errors: [],
  initialFetchMade: false,
  isFetching: false,
  systemWebhooksList: [],
};

const systemWebhooksReducer = (state = initialState, action: SystemWebhookReducerAction) => {
  switch (action.type) {
    case t.CREATE_SYSTEM_WEBHOOK_REQUEST:
    case t.DELETE_SYSTEM_WEBHOOK_REQUEST:
    case t.FETCH_SYSTEM_WEBHOOKS_REQUEST:
    case t.VALIDATE_SYSTEM_WEBHOOK_REQUEST:
    case t.UPDATE_SYSTEM_WEBHOOK_REQUEST: {
      return {
        ...state,
        isFetching: true,
        errors: [],
      };
    }

    case t.SYSTEM_WEBHOOK_ERROR: {
      return {
        ...state,
        isFetching: false,
        errors: [...action.errors],
      };
    }

    case t.CREATE_SYSTEM_WEBHOOK_RESPONSE: {
      return {
        ...state,
        systemWebhooksList: [...state.systemWebhooksList, action.payload],
      };
    }

    case t.FETCH_SYSTEM_WEBHOOKS_RESPONSE: {
      return {
        ...state,
        isFetching: false,
        systemWebhooksList: action.response,
        initialFetchMade: true,
      };
    }

    default: {
      return state;
    }
  }
};

export default systemWebhooksReducer;
